import {CustomAttributeFilterOption} from "./filter.service";

export const FiltersPerCustomer: { [key: string]: Array<CustomAttributeFilterOption> } = {
  'overheaddoor': [
    {
      label: 'Modern',
      customAttribute: {
        attributeName: 'collection',
        values: ['modern'],
      },
      img: '../../../../../assets/custom-attributes-filters/overheaddoor/modern.jpg',
    },

    {
      label: 'Carriage House',
      customAttribute: {
        attributeName: 'collection',
        values: ['carriage-house'],
      },
      img: '../../../../../assets/custom-attributes-filters/overheaddoor/carriage-house.jpg',
    },

    {
      label: 'Wood Plank',
      customAttribute: {
        attributeName: 'collection',
        values: ['wood-plank'],
      },
      img: '../../../../../assets/custom-attributes-filters/overheaddoor/wood-plank.jpg',
    },
    {
      label: 'Classic Doors',
      customAttribute: {
        attributeName: 'collection',
        values: ['classic'],
      },
      img: '../../../../../assets/custom-attributes-filters/overheaddoor/classic-doors.jpg',
    },
  ],
  'wayne-dalton': [
    {
      label: 'Modern',
      customAttribute: {
        attributeName: 'panel-style',
        values: ['modern'],
      },
      img: '../../../../../assets/custom-attributes-filters/wayne-dalton/modern.jpg',
    },

    {
      label: 'Carriage House',
      customAttribute: {
        attributeName: 'panel-style',
        values: ['carriage-house'],
      },
      img: '../../../../../assets/custom-attributes-filters/wayne-dalton/carriage-house.jpg',
    },

    {
      label: 'Traditional',
      customAttribute: {
        attributeName: 'panel-style',
        values: ['traditional'],
      },
      img: '../../../../../assets/custom-attributes-filters/wayne-dalton/traditional.jpg',
    },
  ],
}
